import ScrollMagic from 'scrollmagic'

export function sminit() {
    const pathname = location.pathname;

    let controller = new ScrollMagic.Controller();
    class ScrollFade {
        constructor() {
            this.ANIMATION_CLASS = 'is-fire';
            this.ANIMATION_END_CLASS = 'is-end';

            let $section = document.querySelectorAll('.js-scroll:not(.is-fire)');
            if ($section.length === null) {
                return;
            }
            // let controller = new ScrollMagic.Controller();
            for (let i = 0; i < $section.length; i++) {
                let scene = new ScrollMagic.Scene({
                    triggerElement: $section[i],
                    triggerHook: 'onEnter',
                    reverse: false,
                    offset: 150
                })
                    .addTo(controller);
                scene.on('enter', () => {
                    $section[i].classList.add(this.ANIMATION_CLASS);
                    setTimeout(() => {
                        $section[i].classList.add(this.ANIMATION_END_CLASS);
                    }, 1000)
                });
                scene.on('end', () => {
                    scene.destroy(true);
                });
            }
        }
    }

    new ScrollFade();

    if (location.pathname == "/") {
        const lineAnim = document.querySelector('#future__bg');
        const scene1 = new ScrollMagic.Scene({
            triggerElement: "#future",
            triggerHook: 'onEnter',
            duration: 2000
        })
            .on("progress", function (prog) { // 使いたいシーンに対してprogressイベントを設定します
                var p = prog.progress; // 0～1の値が入ってきます
                lineAnim.style.left = `${10 - 100 * p}%`
            })
            .addTo(controller);
    }
}